const TITLE_KEYS = {
	application_received: 'notification.title.application-received',
	application_submitted: 'notification.title.application-submitted',
	invitation_received: 'notification.title.invitation-received',
	assessment_invitation_received:
		'notification.title.assessment-invitation-received',
	role_changed: 'notification.title.role-changed',
	generic: null
}

const SUBTYPE_TITLE_KEYS = {
	invitation_response: {
		accepted: 'notification.title.invitation-accepted',
		declined: 'notification.title.invitation-declined'
	},
	application_status: {
		accepted: 'notification.title.application-accepted',
		interview: 'notification.title.application-interview',
		hired: 'notification.title.application-hired',
		denied: 'notification.title.application-rejected',
		rejected: 'notification.title.application-rejected'
	}
}

const MESSAGE_KEYS = {
	application_received: {
		key: 'notification.message.application-received',
		required: ['actor_name', 'job_title', 'company_name']
	},
	application_submitted: {
		key: 'notification.message.application-submitted',
		required: ['job_title', 'company_name']
	},
	invitation_received: {
		key: 'notification.message.invitation-received',
		required: ['job_title', 'company_name']
	},
	assessment_invitation_received: {
		key: 'notification.message.assessment-invitation-received',
		required: ['job_title', 'company_name']
	},
	invitation_response: {
		accepted: {
			key: 'notification.message.invitation-accepted',
			required: ['actor_name', 'job_title', 'company_name']
		},
		declined: {
			key: 'notification.message.invitation-declined',
			required: ['actor_name', 'job_title', 'company_name']
		}
	},
	application_status: {
		accepted: {
			key: 'notification.message.application-accepted',
			required: ['job_title', 'company_name']
		},
		interview: {
			key: 'notification.message.application-interview',
			required: ['job_title', 'company_name']
		},
		hired: {
			key: 'notification.message.application-hired',
			required: ['job_title', 'company_name']
		},
		denied: {
			key: 'notification.message.application-rejected',
			required: ['job_title', 'company_name']
		},
		rejected: {
			key: 'notification.message.application-rejected',
			required: ['job_title', 'company_name']
		}
	},
	role_changed: {
		key: 'notification.message.role-changed',
		required: ['company_name', 'role_label']
	}
}

const LEGEND_KEYS = {
	assessment_invitation_received:
		'notification.legend.assessment-invitation-received'
}

const ROLE_LABEL_KEYS = {
	admin: 'notification.role-label.admin',
	administrator: 'notification.role-label.admin',
	member: 'notification.role-label.member'
}

const APPEARANCES = {
	application_received: {
		iconComponent: 'IconFile',
		badgeClass: 'bg-[#466BE5] text-white',
		accentClass: 'bg-[#466BE5]'
	},
	application_submitted: {
		iconComponent: 'IconFile',
		badgeClass: 'bg-[#457F98] text-white',
		accentClass: 'bg-[#457F98]'
	},
	invitation_received: {
		iconComponent: 'IconFile',
		badgeClass: 'bg-[#466BE5] text-white',
		accentClass: 'bg-[#466BE5]'
	},
	assessment_invitation_received: {
		iconComponent: 'IconClipboard',
		badgeClass: 'bg-[#457F98] text-white',
		accentClass: 'bg-[#457F98]'
	},
	invitation_response: {
		accepted: {
			iconComponent: 'IconCheck',
			badgeClass: 'bg-[#3C7D5A] text-white',
			accentClass: 'bg-[#3C7D5A]'
		},
		declined: {
			iconComponent: 'IconTimes',
			badgeClass: 'bg-[#DC3326] text-white',
			accentClass: 'bg-[#DC3326]'
		}
	},
	application_status: {
		accepted: {
			iconComponent: 'IconCheck',
			badgeClass: 'bg-[#3C7D5A] text-white',
			accentClass: 'bg-[#3C7D5A]'
		},
		interview: {
			iconComponent: 'IconFile',
			badgeClass: 'bg-[#457F98] text-white',
			accentClass: 'bg-[#457F98]'
		},
		hired: {
			iconComponent: 'IconCheck',
			badgeClass: 'bg-emerald-600 text-white',
			accentClass: 'bg-emerald-600'
		},
		denied: {
			iconComponent: 'IconTimes',
			badgeClass: 'bg-[#DC3326] text-white',
			accentClass: 'bg-[#DC3326]'
		},
		rejected: {
			iconComponent: 'IconTimes',
			badgeClass: 'bg-[#DC3326] text-white',
			accentClass: 'bg-[#DC3326]'
		}
	},
	role_changed: {
		iconComponent: 'IconCheck',
		badgeClass: 'bg-[#3C7D5A] text-white',
		accentClass: 'bg-[#3C7D5A]'
	},
	generic: {
		iconComponent: 'IconFile',
		badgeClass: 'bg-neutral-500 text-white',
		accentClass: 'bg-neutral-500'
	}
}

const APPLICANT_APPEARANCES = {
	application_submitted: {
		iconComponent: 'IconFile',
		badgeClass: 'bg-[#457F98] text-white',
		accentClass: 'bg-[#457F98]'
	},
	invitation_received: {
		iconComponent: 'IconFilePlus',
		badgeClass: 'bg-[#466BE5] text-white',
		accentClass: 'bg-[#466BE5]'
	},
	application_status: {
		rejected: {
			iconComponent: 'IconFileTimes',
			badgeClass: 'bg-[#DC3326] text-white',
			accentClass: 'bg-[#DC3326]'
		}
	}
}

const NOTIFICATION_MEDIA_TARGETS = {
	application_received: 'applicant',
	application_submitted: 'organization',
	invitation_response: 'applicant',
	invitation_received: 'organization',
	assessment_invitation_received: 'organization',
	application_status: 'organization',
	role_changed: 'organization'
}

function normalizeSubtype(notification) {
	const subtype = notification?.subtype || null

	if (notification?.kind === 'application_status' && subtype === 'denied') {
		return 'rejected'
	}

	return subtype
}

function notificationTitleCanFallbackToJobTitle(notification) {
	return [
		'application_received',
		'application_submitted',
		'invitation_received',
		'assessment_invitation_received',
		'invitation_response',
		'application_status'
	].includes(notification?.kind)
}

function getReplacementValues(notification, translate) {
	const data = notification?.data || {}
	const fallbackTitle = replaceDynamicValues(
		replaceInterfaceStrings(data.title, translate),
		data
	)
	const fallbackJobTitle = notificationTitleCanFallbackToJobTitle(
		notification
	)
		? fallbackTitle
		: ''

	return {
		...data,
		actor_name: data.actor_name || data.firstname || '',
		job_title: data.job_title || fallbackJobTitle || '',
		company_name: data.company_name || data.company || '',
		role: data.role || '',
		role_label: getRoleLabel(data.role, translate),
		email: data.email || ''
	}
}

function getRoleLabel(role, translate) {
	const normalizedRole = String(role || '').toLowerCase()
	const roleLabelKey = ROLE_LABEL_KEYS[normalizedRole] || null

	return roleLabelKey
		? translateSafely(translate, roleLabelKey)
		: normalizedRole
}

function getMessageDefinition(notification) {
	const kind = notification?.kind || 'generic'
	const subtype = normalizeSubtype(notification)
	const definition = MESSAGE_KEYS[kind]

	if (!definition) {
		return null
	}

	if (definition.key) {
		return definition
	}

	return subtype ? definition[subtype] || null : null
}

function hasRequiredValues(values, required = []) {
	return required.every(key => Boolean(values[key]))
}

function translateSafely(translate, key) {
	if (typeof key !== 'string' || key.length === 0) {
		return ''
	}

	if (typeof translate !== 'function') {
		return key
	}

	try {
		const translated = translate(key)
		return typeof translated === 'string' ? translated : key
	} catch (error) {
		return key
	}
}

export function replaceInterfaceStrings(value, translate) {
	if (typeof value !== 'string' || !value.includes(':::')) {
		return typeof value === 'string' ? value : ''
	}

	return value.replace(/:::(.*?):::/g, (match, key) => {
		return translateSafely(translate, key)
	})
}

export function replaceDynamicValues(value, replacements = {}) {
	if (typeof value !== 'string') {
		return ''
	}

	return value.replace(/:([a-zA-Z0-9_]+)/g, (match, key) => {
		const replacement = replacements[key]
		return replacement === undefined || replacement === null
			? ''
			: String(replacement)
	})
}

export function resolveNotificationContent(notification, translate) {
	const replacements = getReplacementValues(notification, translate)
	const subtype = normalizeSubtype(notification)
	const messageDefinition = getMessageDefinition(notification)
	const fallbackTitle = replaceDynamicValues(
		replaceInterfaceStrings(notification?.data?.title, translate),
		replacements
	).trim()
	const fallbackMessage = replaceDynamicValues(
		replaceInterfaceStrings(notification?.data?.message, translate),
		replacements
	).trim()

	const titleKey =
		(SUBTYPE_TITLE_KEYS[notification?.kind] || {})[subtype] ||
		TITLE_KEYS[notification?.kind] ||
		null

	const title = titleKey
		? replaceDynamicValues(
				translateSafely(translate, titleKey),
				replacements
		  )
		: fallbackTitle
	const legendKey = LEGEND_KEYS[notification?.kind] || null
	const translatedLegend = legendKey
		? replaceDynamicValues(
				translateSafely(translate, legendKey),
				replacements
		  )
		: ''
	const message =
		messageDefinition &&
		hasRequiredValues(replacements, messageDefinition.required)
			? replaceDynamicValues(
					translateSafely(translate, messageDefinition.key),
					replacements
			  )
			: fallbackMessage

	return {
		title: title.trim(),
		message: message.trim(),
		legend:
			translatedLegend ||
			replacements.job_title ||
			(notificationTitleCanFallbackToJobTitle(notification)
				? fallbackTitle
				: ''),
		url: notification?.data?.url || null
	}
}

function resolveAppearance(appearances, notification) {
	const kind = notification?.kind || 'generic'
	const subtype = normalizeSubtype(notification)
	const appearance = appearances[kind]

	if (!appearance) {
		return null
	}

	if (appearance.iconComponent) {
		return appearance
	}

	return appearance[subtype] || null
}

export function getNotificationAppearance(notification, options = {}) {
	if (options.isApplicant) {
		const applicantAppearance = resolveAppearance(
			APPLICANT_APPEARANCES,
			notification
		)

		if (applicantAppearance) {
			return applicantAppearance
		}
	}

	return resolveAppearance(APPEARANCES, notification) || APPEARANCES.generic
}

export function getNotificationMedia(notification) {
	const kind = notification?.kind || 'generic'
	const target = NOTIFICATION_MEDIA_TARGETS[kind] || 'applicant'
	const data = notification?.data || {}

	if (target === 'organization') {
		return {
			imageUrl: data.organization_logo_url || null,
			fallbackIcon: 'organization'
		}
	}

	return {
		imageUrl: data.applicant_avatar_url || null,
		fallbackIcon: 'applicant'
	}
}
